module.exports = "/assets/data/7bfc49c7f877c492e9ba25db7c12834b-NR33.data.json";